module.exports = __webpack_public_path__ + "static/media/tick.993555a5.svg";